module.exports = __webpack_public_path__ + "static/media/applenav-shop1.48ad2bb9.PNG";